var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#EF6E64"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4_4574",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4_4574)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9053 19.8733L31.1789 11.5996C31.5579 11.2207 31.5579 10.6522 31.1789 10.2733L29.8526 8.94698C29.4737 8.56803 28.9053 8.56803 28.5263 8.94698L20.2526 17.2207C20 17.4733 19.621 17.4733 19.3684 17.2207L11.0947 8.88382C10.7158 8.50487 10.1474 8.50487 9.76842 8.88382L8.4421 10.2101C8.06316 10.5891 8.06316 11.1575 8.4421 11.5365L16.7158 19.8101C16.9684 20.0628 16.9684 20.4417 16.7158 20.6943L8.37894 29.0312C8 29.4101 8 29.9786 8.37894 30.3575L9.70526 31.6838C10.0842 32.0628 10.6526 32.0628 11.0316 31.6838L19.3684 23.4101C19.621 23.1575 20 23.1575 20.2526 23.4101L28.5263 31.6838C28.9053 32.0628 29.4737 32.0628 29.8526 31.6838L31.1789 30.3575C31.5579 29.9786 31.5579 29.4101 31.1789 29.0312L22.9053 20.7575C22.7158 20.5049 22.7158 20.1259 22.9053 19.8733Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.a44b8fed9c18db4abfbf88a8949e0ab8.svg";
export { ForwardRef as ReactComponent };